import * as React from "react";
import { JSX } from "react/jsx-runtime";
const CalenderIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 2.66683V1.3335V2.66683ZM10 2.66683V4.00016V2.66683ZM10 2.66683H7H10ZM2 6.66683V12.6668C2 13.4032 2.59695 14.0002 3.33333 14.0002H12.6667C13.4031 14.0002 14 13.4032 14 12.6668V6.66683H2Z"
      stroke="#004E9B"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 6.6665V3.99984C2 3.26346 2.59695 2.6665 3.33333 2.6665H4.66667"
      stroke="#004E9B"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66669 1.3335V4.00016"
      stroke="#004E9B"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 6.6665V3.99984C14 3.26346 13.403 2.6665 12.6666 2.6665H12.3333"
      stroke="#004E9B"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CalenderIcon;
